import React from 'react';
import PropTypes from 'prop-types';

import configs from 'configs';


class Tracking extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    if (configs.pendo && configs.pendo.enabled) {
      const { code, email, name, roleName, creationDate, groupCode, groupName, groupType } = this.props;
      (function(apiKey){
        (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=[];
          v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
            o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
          y=e.createElement(n);y.id="pendo";y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
          z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
      })(configs.pendo.key);

      setTimeout(() => {
        if (document.getElementById('pendo')) {
          pendo.initialize({
            visitor: {
              id: code,
              email: email,
              full_name: name,
              role: roleName,
              creationDate: creationDate,
            },

            account: {
              id: groupCode,
              name: groupName,
              type: groupType,
            },
          });
        }
      }, 300);
    }
  }

  render() {
    return null;
  }
}

Tracking.defaultProps = {
  groupName: '',
  groupCode: '',
  groupType: '',
  creationDate: '',
};

Tracking.propTypes = {
  code: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  roleName: PropTypes.string.isRequired,
  creationDate: PropTypes.string,
  groupName: PropTypes.string,
  groupCode: PropTypes.any,
  groupType: PropTypes.string,
};

export default Tracking;
